module.exports = __webpack_public_path__ + "img/dashboard-reminder.c42ded6b.svg";